import { apiGet, apiSend, setAuthToken } from "./api";
import { AdminUser } from "./types";

export async function loginAdmin(email: string, password: string): Promise<AdminUser> {
  const data = await apiSend("POST", "/auth/login", { email, password });
  setAuthToken(data.token);
  return data.user as AdminUser;
}

export async function fetchCurrentAdmin(): Promise<AdminUser> {
  const data = await apiGet("/auth/me");
  return data.user as AdminUser;
}

export function logoutAdmin(): void {
  setAuthToken(null);
}
